import { Controller } from 'stimulus'

export default class extends Controller {
  static values = {
    endTime: Number,
    units: Object,
  }

  static targets = [
    'days',
    'daysCount',
    'hours',
    'hoursCount',
    'minutes',
    'minutesCount',
    'seconds',
    'secondsCount',
  ]

  connect() {
    this.timer = setInterval(this.updateTimer, 1000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  updateTimer = () => {
    let secondsDiff = Math.floor(
      (this.endTimeValue * 1000 - new Date().valueOf()) / 1000
    )
    if (secondsDiff < 0) {
      secondsDiff = 0
    }
    const lastUpdate = secondsDiff === 0

    const daysDiff = Math.floor(secondsDiff / 86400)
    secondsDiff -= daysDiff * 86400
    const hoursDiff = Math.floor(secondsDiff / 3600)
    secondsDiff -= hoursDiff * 3600
    const minutesDiff = Math.floor(secondsDiff / 60)
    secondsDiff -= minutesDiff * 60

    this.secondsCountTarget.innerHTML =
      (secondsDiff > 9 ? '' : '0') + secondsDiff.toString()
    this.secondsTarget.innerHTML =
      this.unitsValue.seconds[secondsDiff == 1 ? 'one' : 'other']

    this.minutesCountTarget.innerHTML =
      (minutesDiff > 9 ? '' : '0') + minutesDiff.toString()
    this.minutesTarget.innerHTML =
      this.unitsValue.minutes[minutesDiff == 1 ? 'one' : 'other']

    this.hoursCountTarget.innerHTML =
      (hoursDiff > 9 ? '' : '0') + hoursDiff.toString()
    this.hoursTarget.innerHTML =
      this.unitsValue.hours[hoursDiff == 1 ? 'one' : 'other']

    this.daysCountTarget.innerHTML =
      (daysDiff > 9 ? '' : '0') + daysDiff.toString()
    this.daysTarget.innerHTML =
      this.unitsValue.days[daysDiff == 1 ? 'one' : 'other']

    if (lastUpdate) {
      clearInterval(this.timer)
    }
  }
}
